import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  GroupedSearchFilterFacet,
  QueryableFilter,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.search}filteredusers`;

export interface SearchUserResultDto {
  userId: string;
  lastname?: string;
  firstname?: string;
  mail?: string;
  profiles?: string[];
  standardProfiles?: string[];
  roles?: string[];
  permissions?: string[];
  allowAllStores: boolean;
  allowAllSuppliers: boolean;
  allowAllWarehouses: boolean;

  assignedSites: string[];
  assignedStores: string[];
  assignedSuppliers: string[];
  assignedWarehouses: string[];
  allowedStocks: string[];

  creationDate?: string;
  lastConnectionDate?: string;
  isActive: boolean;
  deactivationDate?: string;
}

export interface FilterUsersCommandArgs {
  query?: string;
  pageSize?: number;
  page?: number;
  isDescending?: boolean;
  sort?: string;
  filters?: SearchFilterFacet[];
  groupedFilters?: GroupedSearchFilterFacet[];
  dateTimeFilters?: DateTimeFilter[];
  queryableFilters?: QueryableFilter[];
  sortOptions?: SortOption[];
  sellerId?: string;
  tenantId?: string;
  selectedColumns?: any[];
}

async function filterUsersCommand({
  query,
  filters,
  page,
  pageSize,
  sort,
  isDescending,
  dateTimeFilters,
  sortOptions,
  groupedFilters,
  queryableFilters,
  selectedColumns,
  sellerId,
  tenantId,
}: FilterUsersCommandArgs): Promise<
  BackResponse<SearchResultList<SearchUserResultDto>> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<SearchResultList<SearchUserResultDto>>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.POST,
        json: {
          query,
          filters,
          page,
          pageSize,
          sort,
          isDescending,
          dateTimeFilters,
          sortOptions,
          groupedFilters,
          queryableFilters,
          selectedColumns,
          sellerId,
          tenantId,
        },
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default filterUsersCommand;
